/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import { Vector2dPb } from "../eigen_lcm/Vector2d";

export const protobufPackage = "body";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface GpsOrigin {
  utime: number;
  latLon: Vector2dPb | undefined;
  altitude: number;
}

function createBaseGpsOrigin(): GpsOrigin {
  return { utime: 0, latLon: undefined, altitude: 0 };
}

export const GpsOrigin = {
  encode(message: GpsOrigin, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(8).sint64(message.utime);
    }
    if (message.latLon !== undefined) {
      Vector2dPb.encode(message.latLon, writer.uint32(18).fork()).ldelim();
    }
    if (message.altitude !== 0) {
      writer.uint32(25).double(message.altitude);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GpsOrigin {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGpsOrigin();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.utime = longToNumber(reader.sint64() as Long);
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.latLon = Vector2dPb.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 25) {
            break;
          }

          message.altitude = reader.double();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GpsOrigin {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      latLon: isSet(object.latLon) ? Vector2dPb.fromJSON(object.latLon) : undefined,
      altitude: isSet(object.altitude) ? globalThis.Number(object.altitude) : 0,
    };
  },

  toJSON(message: GpsOrigin): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.latLon !== undefined) {
      obj.latLon = Vector2dPb.toJSON(message.latLon);
    }
    if (message.altitude !== 0) {
      obj.altitude = message.altitude;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GpsOrigin>, I>>(base?: I): GpsOrigin {
    return GpsOrigin.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GpsOrigin>, I>>(object: I): GpsOrigin {
    const message = createBaseGpsOrigin();
    message.utime = object.utime ?? 0;
    message.latLon = (object.latLon !== undefined && object.latLon !== null)
      ? Vector2dPb.fromPartial(object.latLon)
      : undefined;
    message.altitude = object.altitude ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
